<template>
  <div class="content ">
    <div class="contact">
      <p class="title">{{ title }}</p>
      <div class="desc">
        Contact Us for Support & Feedback. For all inquiries, feedback, or assistance, please email our team directly at <a href="mailto: alleshen777@gmail.com">alleshen777@gmail.com</a>. We are committed to providing you with excellent support and welcome your messages.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      desc: [],
      email: "",
    };
  },
  computed: {
    textColor: function() {
      return this.$store.state.data.theme.desc_color;
    },
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      const { title, desc } = config.page[2];
      this.email = config.email;
      this.title = title;
      this.desc = desc;
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  // padding: 10px 0;
  padding: 0;
  flex: 1;
  // background-image: url("~@/assets/images/contact.png");
  background-size: cover;
  // width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #000;
  .title{
    margin: 0;
    text-align: center;
    color: #fff;
  }
  .contact {
    // transform: translateX(-100%);
    max-width: 800px;
    .desc{
      margin-top: 16px;
      color: #adb7be;
      font-size: 16px;
      line-height: 24px;
      a{
        font-weight: 700;
        font-style: italic;
        color: #c9c9c9;
        text-decoration: underline;
        &:hover{
          color: #fff;
        }
      }
    }
    // .desc {
    //   div {
    //     margin-bottom: 15px;
    //   }
    //   ul {
    //     margin-top: 10px;
    //   }
    //   ul li {
    //     margin-left: 20px;
    //     font-size: 12px;
    //   }
    // }
  }
}
</style>
